const Minimize = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAHCAYAAAA4R3wZAAAAAXNSR0IArs4c6QAAAG9JREFUGBljYACC////e4BoYgBQrTtYHZBhBMT/gHgJEHPg0gySg6oBqTWCaQ4Ecr4A8QkglkDXDBID4uNADFITiCIPFDAA4kdQbACTxCUOkwfTQEUoJgP5eF2CrhnZLwT9jqIZxAHaVgXCGBJQAQA3r5LsE4VPvQAAAABJRU5ErkJggg==";
export {
  Minimize as default
};
//# sourceMappingURL=Minimise.png.js.map
